import React from 'react';

import GlobalStyles from './styles/GlobalStyles'
import Routes from './Routes';

function App() {
  return (
    <div className="App">
      <GlobalStyles />
      <Routes />
    </div>
  );
}

export default App;
